export default __webpack_public_path__ + "static/media/admin_filter_active.c39e9b4e.svg";